import React, { useState } from 'react'
import './index.scss'

import { makeStyles } from '@material-ui/core/styles'
// import DialogTitle from '@material-ui/core/DialogTitle'
import Dialog from '@material-ui/core/Dialog'
import { Alert, AlertTitle } from '@material-ui/lab'

const useStyles = makeStyles(theme => ({
    root: {
        width: '400px',
        fontSize: '20px',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
}))

const AlertLabel = () => {
    const classes = useStyles()

    const [show, setShow] = useState(true)

    return (
        <React.Fragment>
            <Dialog
                onClose={() => setShow(false)}
                aria-labelledby='simple-dialog-title'
                open={show}
            >
                <div className={classes.root}>
                    <Alert severity='error'>
                        <AlertTitle>
                            Someone is working with this lead!
                        </AlertTitle>
                        <strong
                            onClick={() => setShow(false)}
                            style={{
                                textDecoration: 'underline',
                                cursor: 'pointer',
                            }}
                        >
                            close
                        </strong>
                    </Alert>
                </div>
            </Dialog>
        </React.Fragment>
    )
}

export default AlertLabel
